/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddUltimateBeneficialOwnerOutput
 */
export interface AddUltimateBeneficialOwnerOutput {
    /**
     * 
     * @type {number}
     * @memberof AddUltimateBeneficialOwnerOutput
     */
    ultimateBeneficialOwnerId?: number;
    /**
     * 
     * @type {Error}
     * @memberof AddUltimateBeneficialOwnerOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the AddUltimateBeneficialOwnerOutput interface.
 */
export function instanceOfAddUltimateBeneficialOwnerOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AddUltimateBeneficialOwnerOutputFromJSON(json: any): AddUltimateBeneficialOwnerOutput {
    return AddUltimateBeneficialOwnerOutputFromJSONTyped(json, false);
}

export function AddUltimateBeneficialOwnerOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddUltimateBeneficialOwnerOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ultimateBeneficialOwnerId': !exists(json, 'ultimateBeneficialOwnerId') ? undefined : json['ultimateBeneficialOwnerId'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function AddUltimateBeneficialOwnerOutputToJSON(value?: AddUltimateBeneficialOwnerOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ultimateBeneficialOwnerId': value.ultimateBeneficialOwnerId,
        'error': value.error,
    };
}

